module.exports = __webpack_public_path__ + "static/media/orange_animal_amphibians_6.67a0122d.webp";